// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6925a99f","337":"324fa092","453":"3f2eb866","455":"729c03c2"}[chunkId] + ".chunk.js";
};